import React from 'react';
import { dummyClick, emptyFunction } from '../utilities';
import { WhiteLink } from '../buttons';


const MobileAccountNav = ({
  opened, userImg, userName, caretImg, onToggleClick, t: {
    profile, notifications, settings, logOut
  }
}) => (
  <li className="t-pa2">
    <img
      className="left br-100"
      src={userImg}
      alt="user-thumbnail"
      width="32px"
      onClick={onToggleClick}
    />
    <WhiteLink
      className="left truncate ml1 a-max-width-1 t-pt1"
      text={userName}
      onClick={onToggleClick}
    />
    <img
      className="right t-pv2"
      src={caretImg}
      alt="caret"
      onClick={onToggleClick}
    />
    <ul className={`list t-pl0 cb t-ml2 a-mobile-user-menu ${opened ? 'opened' : ''}`}>
      <li className="t-pv1 lh-copy">
        <WhiteLink path="/profile_edit" text={profile} onClick={emptyFunction} />
      </li>
      <li className="t-pv1 lh-copy">
        <WhiteLink path="/notifications" text={notifications} onClick={emptyFunction} />
      </li>
      <li className="t-pv1 lh-copy">
        <WhiteLink path="/settings" text={settings} onClick={emptyFunction} />
      </li>
      <li className="t-pv1 lh-copy">
        <WhiteLink text={logOut} onClick={signOut} />
      </li>
    </ul>
  </li>
);

MobileAccountNav.defaultProps = {
  opened: false,
  userImg: '/images/sample_images/sample_jpg.jpg',
  userName: 'EN userName',
  caretImg: '/images/sample_images/sample_jpg.jpg',
  onToggleClick: dummyClick,
  t: {
    profile: 'EN profile',
    notifications: 'EN notifications',
    settings: 'EN settings',
    logOut: 'EN logOut'
  }
};

export default MobileAccountNav;